<script>
import classModifierMixin from './mixins/class-modifier-mixin'
export default {
	name: 'BaseContainer',
	mixins: [classModifierMixin]
}
</script>
<template>
	<div class="base-container" :class="modifierClasses">
		<slot></slot>
	</div>
</template>

<style lang="scss">
	.base-container {
		height: 100%;
		width: 100%;
		margin: 0 auto;
		&--default-width {
			max-width: var(--container-width);
		}
		&--half-width {
			max-width: calc(var(--container-width)/2);
		}
		&--relative-width {
			max-width: 70%;
			@media (max-width: 500px) {
				max-width: 100%;
			}
		}
		&--height {
			height: calc(100vh - var(--header-height));
		}
		&--padding {
			padding: 1rem 2rem 1rem 2rem;
		}
		&--column-layout {
			display: flex;
			flex-direction: column;
		}
		&--align-center {
			align-items: center;
		}
		&--space-evenly {
			justify-content: space-evenly;
		}
		&--responsive {
			@media (max-width: 800px) {
				padding: 0 0.5rem;
			}
		}
		&--stretched {
			@media (max-width: 500px) {
				margin-left: -1rem;
				margin-right: -1rem;
				width: calc(100% + 2rem);
			}
		}
	}
</style>
